import React from 'react';
import { styled } from '@compiled/react';
import { format } from 'date-fns';
import Heading from '@atlaskit/heading';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { DAY_VIEW_COLUMN_HOUR_INTERVAL } from '../../../../common/constants';

type APIProps = {
	isHighlightToday: boolean;
	hours: number[];
	date: Date;
	today: Date;
};

type Props = APIProps;

const isSameDate = (dateA: Date, dateB: Date) => dateA.toDateString() === dateB.toDateString();

const DayCell = ({ hours, isHighlightToday, date, today }: Props) => (
	<>
		<Heading level="h100">
			<StyledHeader highlight={isHighlightToday && isSameDate(today, date)}>
				{format(date, 'EEE, MMM do')}
			</StyledHeader>
		</Heading>

		<HoursContainer>
			{hours.map((hour, dayIndex) => (
				<Hour key={dayIndex} isHighlighted={false}>
					{hour}
				</Hour>
			))}
		</HoursContainer>
	</>
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Header = styled.span({
	textTransform: 'uppercase',
	marginTop: 0,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const StyledHeader = styled(Header)<{ highlight: boolean }>({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	color: ({ highlight }) =>
		highlight
			? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
				`${token('color.text.information', colors.B200)} !important;`
			: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
				`${token('color.text.subtlest', colors.N300)}`,
	marginTop: token('space.050', '4px'),
});

const hourWidth = (1 / (24 / DAY_VIEW_COLUMN_HOUR_INTERVAL)) * 100;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Hour = styled.span<{ isHighlighted: boolean }>({
	flex: '0 0 auto',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	width: `${hourWidth}%`,
	font: token('font.body.UNSAFE_small'),
	textAlign: 'center',
	overflowWrap: 'break-word',
	boxSizing: 'border-box',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	color: ({ isHighlighted }) =>
		isHighlighted
			? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
				`${token('color.text.information', colors.B200)} !important`
			: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
				`${token('color.text.subtlest', colors.N300)}`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const HoursContainer = styled.div({
	flex: '1 1 auto',
	display: 'flex',
	alignItems: 'center',
	width: '100%',
});

export default DayCell;
export type { APIProps };
